export const labelCls = "mb-1.5 block text-sm font-medium text-zinc-300";

export const inputCls =
  "w-full rounded-xl border border-white/15 bg-white/5 px-3.5 py-2.5 text-zinc-100 outline-none ring-cyan-500/25 placeholder:text-zinc-500 focus:border-cyan-400/45 focus:bg-white/[0.09] focus:ring-2";

export const fieldHintCls = "mt-1 text-xs text-zinc-500";

export const errorTextCls = "text-sm font-medium text-red-400";

/** Inline links — cool accent, restrained */
export const linkAccentCls =
  "font-medium text-cyan-300/90 underline-offset-4 hover:text-cyan-200 hover:underline";

export const btnPrimaryCls =
  "inline-flex items-center justify-center rounded-full bg-gradient-to-r from-cyan-500 to-violet-600 px-6 py-2.5 text-sm font-semibold text-white shadow-lg shadow-cyan-500/18 ring-1 ring-white/15 transition hover:from-cyan-400 hover:to-violet-500 hover:shadow-cyan-400/22 disabled:pointer-events-none disabled:opacity-50";

export const btnGhostCls =
  "whitespace-nowrap rounded-full border border-white/12 bg-white/[0.06] px-4 py-2 text-sm font-medium text-zinc-100 shadow-[inset_0_1px_0_0_rgba(255,255,255,0.06)] backdrop-blur-md transition hover:border-white/18 hover:bg-white/[0.1]";

/** Header / dense rows — same ghost style, tighter padding on narrow screens */
export const btnGhostHeaderCls =
  `${btnGhostCls} shrink-0 px-3 py-1.5 text-xs sm:px-4 sm:py-2 sm:text-sm`;

export const btnPrimaryHeaderCls =
  "inline-flex shrink-0 items-center justify-center whitespace-nowrap rounded-full bg-gradient-to-r from-cyan-500 to-violet-600 px-3 py-1.5 text-xs font-semibold text-white shadow-md shadow-cyan-500/15 ring-1 ring-white/12 transition hover:from-cyan-400 hover:to-violet-500 sm:px-4 sm:py-2 sm:text-sm";
